<div class="elapsed-time">{{timeDifference}}</div>